export default __webpack_public_path__ + "static/media/games-banners-cn.2762e69b.webp";